import React, { useState } from "react";
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from "react-icons/bs";
import "../css/ImageSliderProjects.css";

export const ImageSliderProjects = ({ data = [] }) => {
  const [slide, setSlide] = useState(0);

  const nextSlide = () => {
    setSlide((slide + 1) % data.length); // Use modulo to loop back to beginning
  };

  const prevSlide = () => {
    setSlide((slide - 1 + data.length) % data.length); // Handle negative indices correctly
  };

  return (
    
    <div className="carousel-small-slider-project">
      {
        data.length==0 && (
          <p style={{fontSize:"50px",backgroundColor:"black",color:"white",padding:"80px",borderRadius:"70px",textAlign:"center"}}>No Images</p>
        )
      }
      <BsArrowLeftCircleFill onClick={prevSlide} className="arrow-project arrow-left-project" />
      {data.map((item, idx) => (
        <img
          src={item}
          alt={`slide-${idx}`}
          key={idx}
          className={slide === idx ? "slide-project" : "slide-project slide-hidden-project"}
        />
      ))}
      <BsArrowRightCircleFill onClick={nextSlide} className="arrow-project arrow-right-project" />
      <span className="indicators-project">
        {data.map((_, idx) => (
          <button
            key={idx}
            className={slide === idx ? "indicator-project" : "indicator-project indicator-inactive-project"}
            onClick={() => setSlide(idx)}
          ></button>
        ))}
      </span>
    </div>
  );
};



